export default "__VITE_ASSET__7EJH5WNY__"